<template lang="pug">
    div.creator-search-control
        search-control.creator-search-control__search(:value="searchValue" placeholder="Search Creator" @input="updateSearch"
            @focus="focused = true" @blur="focused = false" ref="searchControl")
        div.creator-search-control__popup(:hidden="!hasCreators || (!focused && !hovered)"
                @mouseover="hovered = true" @mouseleave="hovered = false")
            creators-list-control(:creators="creators" @goToProfile="goToProfile")
</template>

<script>
import EventBus from '../../lib/event-bus'
import Events from '../../lib/events'
import userService from '../../services/user-service'

export default {
    name: 'creator-search-control',

    data() {
        return {
            searchValue: '',
            creators: [],
            cancel: null,
            focused: false,
            hovered: false,
        }
    },

    computed: {
        hasCreators() {
            return this.creators.length > 0
        },
    },

    methods: {
        updateSearch(val) {
            this.searchValue = val

            if (this.cancel) {
                this.cancel()
            }

            if (val.length > 2) {
                this.loadCreators()
            }
            else {
                this.creators = []
            }
        },

        activateSearch(search) {
            this.updateSearch(search)
            this.$nextTick(this.$refs.searchControl.focus)
        },

        loadCreators() {
            const { promise, cancel } = userService.search(this.searchValue)

            this.cancel = cancel

            promise.then(({data}) => {
                this.creators = data.data
            })
        },

        goToProfile() {
            this.updateSearch('')
        },
    },

    created() {
        EventBus.$on(Events.SEARCH_CREATOR, this.activateSearch)
    },

    beforeDestroy() {
        EventBus.$off(Events.SEARCH_CREATOR, this.activateSearch)
    },
}
</script>
